if (!customElements.get('load-more-button')) {
  customElements.define(
    'load-more-button',
    class LoadMoreButton extends HTMLElement {
      constructor() {
        super();
        this.link = this.querySelector('.load-more__button');
        this.spinner = this.querySelector('.loading__spinner');
        this.status = this.querySelector('.load-more__status');
        this.gridSelector = this.dataset.gridSelector;
        this.grid = document.querySelector(this.gridSelector);

        this.link.addEventListener('click', this.onClick.bind(this));
      }

      onClick(event) {
        event.preventDefault();
        if (this.link.classList.contains('loading')) return;

        this.link.setAttribute('aria-disabled', 'true');
        this.link.classList.add('loading');
        this.spinner.classList.remove('hidden');

        fetch(this.link.href)
          .then((response) => response.text())
          .then((responseText) => this.renderNextPage(responseText))
          .catch(() => this.stopLoading());
      }

      stopLoading() {
        this.link.classList.remove('loading');
        this.spinner.classList.add('hidden');
        this.link.removeAttribute('aria-disabled');
      }

      renderNextPage(responseText) {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const newGrid = html.querySelector(this.gridSelector);
        const newItems = newGrid ? Array.from(newGrid.children) : [];

        if (this.grid && newItems.length) {
          newItems.forEach((item) => this.grid.appendChild(item));
          if (typeof initializeScrollAnimationTrigger === 'function') {
            initializeScrollAnimationTrigger(this.grid);
          }
        }

        if (this.status && newItems.length) {
          const template =
            newItems.length === 1 ? this.dataset.countTemplateOne : this.dataset.countTemplateOther;
          this.status.textContent = template.replace('__COUNT__', newItems.length);
        }

        const nextButton = html.querySelector('load-more-button .load-more__button');
        this.stopLoading();
        if (nextButton) {
          this.link.href = nextButton.href;
        } else {
          this.remove();
        }
      }
    }
  );
}
